import { useQuery } from "@apollo/client";
import { Avatar } from "antd";

import { getInitials } from "./utils";
import prenodeLogoHeader from "../../assets/prenode_logo_header.png";
import { CurrentUserDocument } from "../../graphql/graphql";
import ToggleMenu from "../Menu/ToggleMenu";

const Header = () => {
  const { data, loading, error } = useQuery(CurrentUserDocument);
  const userName = data?.currentUser?.givenName ?? "";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "100%",
      }}
    >
      <img
        src={prenodeLogoHeader}
        alt="prenode"
        style={{
          width: "140px",
          marginTop: "2px",
          cursor: "pointer",
        }}
        onClick={() => {
          window.location.href = "/";
        }}
      />
      <div style={{ flexGrow: 1 }}></div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          paddingLeft: "50px",
        }}
      >
        {loading || error ? (
          <Avatar icon="user" style={{ backgroundColor: "grey" }} />
        ) : (
          <Avatar style={{ backgroundColor: "grey" }}>
            {getInitials(userName)}
          </Avatar>
        )}
        <ToggleMenu />
      </div>
    </div>
  );
};

export default Header;
